<template>
    <div :style="moduleStyle">
        <slot />
    </div>
</template>

<script setup>
import {useCssVar} from '@vueuse/core'
import {$getModuleColor} from "@/utils/appModules"

const props = defineProps({
    module: {
        type: String,
        required: false,
        default: undefined
    }
})

const hasAppModulesFeature = useFeature('appModules')

const moduleStyle = computed(() => {
    if (!hasAppModulesFeature) return {}
    const moduleColor = $getModuleColor(props.module) ?? 'app'
    return {
        '--color-primary-50': useCssVar(`--color-${moduleColor}-50`).value ? `var(--color-${moduleColor}-50)` : 'var(--color-app-50)',
        '--color-primary-100': useCssVar(`--color-${moduleColor}-100`).value ? `var(--color-${moduleColor}-100)` : 'var(--color-app-100)',
        '--color-primary-200': useCssVar(`--color-${moduleColor}-200`).value ? `var(--color-${moduleColor}-200)` : 'var(--color-app-200)',
        '--color-primary-300': useCssVar(`--color-${moduleColor}-300`).value ? `var(--color-${moduleColor}-300)` : 'var(--color-app-300)',
        '--color-primary-400': useCssVar(`--color-${moduleColor}-400`).value ? `var(--color-${moduleColor}-400)` : 'var(--color-app-400)',
        '--color-primary-500': useCssVar(`--color-${moduleColor}-500`).value ? `var(--color-${moduleColor}-500)` : 'var(--color-app-500)',
        '--color-primary-600': useCssVar(`--color-${moduleColor}-600`).value ? `var(--color-${moduleColor}-600)` : 'var(--color-app-600)',
        '--color-primary-700': useCssVar(`--color-${moduleColor}-700`).value ? `var(--color-${moduleColor}-700)` : 'var(--color-app-700)',
        '--color-primary-800': useCssVar(`--color-${moduleColor}-800`).value ? `var(--color-${moduleColor}-800)` : 'var(--color-app-800)',
        '--color-primary-900': useCssVar(`--color-${moduleColor}-900`).value ? `var(--color-${moduleColor}-900)` : 'var(--color-app-900)',
        '--color-primary-950': useCssVar(`--color-${moduleColor}-950`).value ? `var(--color-${moduleColor}-950)` : 'var(--color-app-950)',
        '--color-primary': useCssVar(`--color-${moduleColor}`).value ? `var(--color-${moduleColor})` : 'var(--color-app)'
    }
})
</script>
